(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var coarse = window.matchMedia && window.matchMedia('(hover: none)').matches;

  /* ------------------------------------------------------------
     1. CINEMA LOADER — first paint, fades after window load
     ------------------------------------------------------------ */
  function initLoader() {
    var loader = document.querySelector('[data-cor-loader]');
    if (!loader) return;
    // show once per session
    var seen = false;
    try { seen = !!sessionStorage.getItem('cor-loader-seen'); } catch (e) {}
    if (seen) {
      loader.remove();
      return;
    }
    try { sessionStorage.setItem('cor-loader-seen', '1'); } catch (e) {}
    // While the full-screen aria-hidden overlay is up, keep keyboard focus out
    // of the page content it visually obscures (WCAG 4.1.2). inert blocks focus
    // + interaction; restored when the loader is removed.
    var main = document.getElementById('MainContent');
    if (main) {
      try { main.inert = true; } catch (e) {}
      main.setAttribute('aria-hidden', 'true');
    }
    var releaseMain = function () {
      if (!main) return;
      try { main.inert = false; } catch (e) {}
      main.removeAttribute('aria-hidden');
    };
    var letters = loader.querySelectorAll('.cor-loader__word span');
    letters.forEach(function (l, i) {
      l.style.animationDelay = (80 + i * 40) + 'ms';
    });
    var minHold = 900;
    var start = performance.now();
    function hide() {
      var elapsed = performance.now() - start;
      var wait = Math.max(0, minHold - elapsed);
      setTimeout(function () {
        loader.classList.add('is-done');
        setTimeout(function () {
          releaseMain();
          // Don't leave focus on the node we're about to remove.
          if (loader.contains(document.activeElement)) {
            try { document.activeElement.blur(); } catch (e) {}
          }
          loader.remove();
        }, 800);
      }, wait);
    }
    if (document.readyState === 'complete') hide();
    else window.addEventListener('load', hide, { once: true });
  }

  /* ------------------------------------------------------------
     2. CURSOR MAGNETISM — elements with [data-cor-magnet]
     ------------------------------------------------------------ */
  function initMagnet() {
    if (reduce || coarse) return;
    // auto-tag primary CTAs on the landing page
    document.querySelectorAll('.cor-btn--primary.cor-btn--lg, [data-cor-cta]').forEach(function (b) {
      b.setAttribute('data-cor-magnet','');
    });
    var nodes = document.querySelectorAll('[data-cor-magnet]');
    if (!nodes.length) return;
    var STRENGTH = 0.32;
    var DIST = 90;
    nodes.forEach(function (el) {
      var rect;
      var update = function (ev) {
        rect = el.getBoundingClientRect();
        var cx = rect.left + rect.width / 2;
        var cy = rect.top + rect.height / 2;
        var dx = ev.clientX - cx;
        var dy = ev.clientY - cy;
        var d = Math.hypot(dx, dy);
        if (d > DIST + Math.max(rect.width, rect.height) / 2) {
          el.style.transform = '';
          return;
        }
        el.style.transform = 'translate3d(' + (dx * STRENGTH) + 'px,' + (dy * STRENGTH) + 'px,0)';
      };
      var reset = function () { el.style.transform = ''; };
      el.addEventListener('pointermove', update, { passive: true });
      el.addEventListener('pointerleave', reset);
      // ambient: respond to mouse moving nearby
      window.addEventListener('pointermove', function (ev) {
        rect = el.getBoundingClientRect();
        if (ev.clientX < rect.left - DIST || ev.clientX > rect.right + DIST ||
            ev.clientY < rect.top - DIST || ev.clientY > rect.bottom + DIST) {
          el.style.transform = '';
        }
      }, { passive: true });
    });
  }

  /* ------------------------------------------------------------
     3. SECTION COLOR CROSSFADE
     ------------------------------------------------------------ */
  var BG_STOPS = {
    ink:         '#07070a',
    carbon:      '#14141c',
    midnight:    '#1c1c28',
    canvas:      '#f6f6f7',
    'signal-tint':'#2a1a1a'
  };
  function hexToRgb(h) {
    var m = h.replace('#','');
    return [parseInt(m.slice(0,2),16), parseInt(m.slice(2,4),16), parseInt(m.slice(4,6),16)];
  }
  function rgbToHex(r,g,b) {
    var s = function (n){ var x = Math.round(n).toString(16); return x.length<2 ? '0'+x : x; };
    return '#' + s(r) + s(g) + s(b);
  }
  function lerp(a,b,t){ return a + (b - a) * t; }
  function mix(c1, c2, t) {
    var a = hexToRgb(c1), b = hexToRgb(c2);
    return rgbToHex(lerp(a[0],b[0],t), lerp(a[1],b[1],t), lerp(a[2],b[2],t));
  }
  function initBgCrossfade() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll('[data-cor-bg-stop]'));
    if (nodes.length < 2) return;
    // Only enable the 1200ms body background transition when motion is allowed.
    // Under prefers-reduced-motion the color still snaps to each stop instantly
    // (no continuous cross-animation on every scroll tick) — WCAG 2.3.3.
    if (!reduce) document.body.setAttribute('data-cor-bg-active','');
    var update = function () {
      var vh = window.innerHeight;
      var mid = vh * 0.5;
      // find which two stops the viewport mid is between
      var sorted = nodes.map(function (n) {
        var r = n.getBoundingClientRect();
        return { n: n, top: r.top, bot: r.bottom, h: r.height };
      });
      var current = sorted[0], next = sorted[1];
      for (var i = 0; i < sorted.length; i++) {
        var s = sorted[i];
        if (s.top <= mid && s.bot >= mid) {
          current = s;
          next = sorted[i+1] || s;
          break;
        }
        if (s.top > mid) {
          current = sorted[Math.max(0, i-1)] || s;
          next = s;
          break;
        }
      }
      if (current === next) {
        document.body.style.backgroundColor = BG_STOPS[current.n.getAttribute('data-cor-bg-stop')] || BG_STOPS.ink;
        return;
      }
      var span = next.top - current.top;
      var raw = (mid - current.top) / Math.max(span, 1);
      var t = Math.max(0, Math.min(1, raw));
      var c1 = BG_STOPS[current.n.getAttribute('data-cor-bg-stop')] || BG_STOPS.ink;
      var c2 = BG_STOPS[next.n.getAttribute('data-cor-bg-stop')] || BG_STOPS.ink;
      document.body.style.backgroundColor = mix(c1, c2, t);
    };
    var ticking = false;
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { update(); ticking = false; });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  /* ------------------------------------------------------------
     4. HERO PARALLAX — slow upward drift on scroll
     ------------------------------------------------------------ */
  function initHeroParallax() {
    if (reduce) return;
    var hero = document.querySelector('[data-cor-hero-parallax]');
    if (!hero) return;
    var ticking = false;
    // When a control inside the hero has keyboard focus, hold full opacity so
    // the focused CTA/link keeps full text + focus-ring contrast (WCAG 2.4.7 / 1.4.3).
    var focusHeld = false;
    var update = function () {
      ticking = false;
      if (focusHeld) return;
      var y = window.scrollY;
      var vh = window.innerHeight;
      // Past one viewport: snap to the deterministic floor so a restored/
      // bfcache-scrolled page never gets stuck at a stale low opacity.
      if (y > vh) {
        hero.style.transform = '';
        hero.style.opacity = String(1 - 0.6);
        return;
      }
      var t = Math.min(1, y / vh);
      hero.style.transform = 'translate3d(0,' + (-y * 0.12) + 'px,0)';
      hero.style.opacity = String(1 - t * 0.6);
    };
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }, { passive: true });
    hero.addEventListener('focusin', function () {
      focusHeld = true;
      hero.style.opacity = '1';
      hero.style.transform = '';
    });
    hero.addEventListener('focusout', function () {
      focusHeld = false;
      update();
    });
    update();
  }

  function init() {
    initLoader();
    initMagnet();
    initBgCrossfade();
    initHeroParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
